
import configDinamicComponenets from "./DinamicComponenets";

import DinamicFormsConfig from './DinamicForms'
import CriarCustomFormConfig from './CriarCustomForm'
import OkReportDeveloperConfig from './OkReportDeveloper'


configDinamicComponenets()


const config = {
    subConfig: [
        DinamicFormsConfig,
        CriarCustomFormConfig,
        OkReportDeveloperConfig
    ],
}


export default config




// WEBPACK FOOTER //
// ./src/routes/sistema/index.js